import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AnalyticEvents } from '@app/enums';
import { AnalyticService, NotifyService } from '@app/services';
import { Employee } from '@models/employee/employee.model';
import { TimeOffRequest } from '@models/time-off-v3/time-off-request.model';

@Component({
    templateUrl: './request-create.template.html',
})
export class RequestCreateView {
    timeOffRequest: TimeOffRequest = new TimeOffRequest();
    hasPoliciesAssigned = false;
    isLoading = false;

    constructor(
        private router: Router,
        private notify: NotifyService,
        route: ActivatedRoute,
        private analyticService: AnalyticService
    ) {
        const employee: Employee = route.snapshot.data.models.get('employee');
        this.hasPoliciesAssigned = !!employee.activeTimeOffPolicies.length;

        // If we have no active policy for the employee we stop here and empty state will handle it
        if (!this.hasPoliciesAssigned) {
            return;
        }

        this.timeOffRequest = new TimeOffRequest({
            startAt: new Date(),
            endAt: new Date(),
            employeeId: employee.id,
        });

        this.timeOffRequest.employee = employee;
    }

    async onSave(timeOffRequest: TimeOffRequest): Promise<void> {
        this.isLoading = true;

        try {
            await timeOffRequest.save();
            this.analyticService.trackEvent(AnalyticEvents.TimeOffCreatingRequest);
            this.notify.success('time-off-v3.requestHasBeenCreatedSuccessfully');
            // The request view component will need to determine where to route on the back button click with this extra state information
            this.router.navigate(['/', 'time-off', 'v3', 'requests', timeOffRequest.id], {
                state: { previousRoute: this.router.url },
            });
        } catch (e) {
            this.notify.error(e);
        } finally {
            this.isLoading = false;
        }
    }
}
